import { render, staticRenderFns } from "./InvoiceTemplate.vue?vue&type=template&id=527d7726&scoped=true"
import script from "./InvoiceTemplate.vue?vue&type=script&lang=js"
export * from "./InvoiceTemplate.vue?vue&type=script&lang=js"
import style0 from "./InvoiceTemplate.vue?vue&type=style&index=0&id=527d7726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527d7726",
  null
  
)

export default component.exports